





































import { Component, Mixins, Prop, Emit, } from "vue-property-decorator";
import { Patient } from "../../../../../domain/patient";
import DuplicatedPatientIndicator from "../../../wizard/guest/DuplicatedPatientIndicator.vue";
import { PatientViewerMixin } from "../../mixins";

@Component({
  components: {
    DuplicatedPatientIndicator,
  }
})
export default class SimplePatientViewer extends Mixins(PatientViewerMixin) {
  @Emit("patientChanged")
  duplicatedPatientSelected(patient: Patient): void {}

  @Prop()
  patient: Patient;

  get sexIcon(): string {
    return "patient-viewer-sex-icon patient-viewer-sex-icon-" + this.sexKey.toLowerCase();
  }
}
